import { AccountPermissions } from '@provider-portal/common/services/types/account';

import { Facade } from '@bolteu/lattice';

/**
 * Permission entry for a menu/category item
 * @template T Is the list of possible permission keys
 * (can also be string for making it generic)
 */
export interface MenuEntryPermissions<T = keyof AccountPermissions> {
  type: 'all' | 'oneOf' | 'noneOf';
  values: T[];
}

export interface ConfigMenuItem {
  id: string;
  titleIntlId: string;
  href: string;
  permission?: MenuEntryPermissions;
  hidden?: boolean;
  order?: number;
  experiment?: Record<string, string>;
  showNewBadge?: boolean;
}
export interface ConfigMenuCategory {
  id: string;
  titleIntlId: string;
  items: ConfigMenuItem[];
  permission?: MenuEntryPermissions;
  hidden?: boolean;
}

export interface ConfigMenu {
  menu: ConfigMenuCategory[];
  activeMenuEntryIdOverride?: string;
}

export function isMenuLink(item?: Facade.MenuNode): item is Facade.MenuLink {
  if (!item) {
    return false;
  }

  return 'link' in item;
}

export function isMenuItem(item?: Facade.MenuNode): item is Facade.MenuItem {
  if (!item) {
    return false;
  }

  return 'children' in item;
}

export interface ConfigTab {
  id: string;
  labelIntlId: string;
  route: string;
  permission?: MenuEntryPermissions;
}

export interface ConfigTabHeader {
  id: string;
  titleIntlId: string;
  associatedMenuEntryId: string;
  tabs: ConfigTab[];
  permission?: MenuEntryPermissions;
}

export interface ConfigTabs {
  tabHeaders: ConfigTabHeader[];
}
